import { SkeletonBlock, SkeletonText } from '@nucleus/web-theme-elements';
import React from 'react';
import styled from 'styled-components';

export const SermonListItemSkeleton = (): JSX.Element => {
  return (
    <Card>
      <Media>
        <ImagePlaceholder />
      </Media>
      <Meta>
        <SkeletonText width="60%" style={{ height: 18, marginBottom: 12 }} />
        <SkeletonText width="45%" style={{ height: 14 }} />
      </Meta>
    </Card>
  );
};

const Card = styled.div`
  border-radius: 10px;
  min-height: 210px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 15px;
  gap: 30px;
  border-bottom: 1px solid ${({ theme }) => theme._webThemeElements.Skeleton?.colorDark ?? 'rgba(0, 0, 0, 0.06)'};

  @media (max-width: 800px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const Media = styled.div`
  flex: 0 0 320px;
  width: 320px;

  @media (max-width: 800px) {
    flex: 0 0 100%;
    width: 100%;
  }
`;

const ImagePlaceholder = styled(SkeletonBlock)`
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 10px;
`;

const Meta = styled.div`
  flex: 1 1 200px;
  display: flex;
  flex-direction: column;
  padding-right: 50px;
`;
